// =====================================
//	確認視窗
//	@author: Alan
//	@time 2015 / 12 / 18
// =====================================

window.InifECApp.directive('confirm', ['$rootScope', '$ngModal', '$timeout',
	function ($rootScope, $ngModal, $timeout) {

		var _dir = {};

		var controller = ['$scope', function($scope) {

            var submit = function() {

                if($scope.waitLoading) {
                    
                    if($scope.isLoading) {
                        return;
                    }
                    $scope.isLoading = true;
                    ($scope.callback) && $scope.callback(true, closeModal);
                } else {
                    ($scope.callback) && $scope.callback(true);
                    closeModal();
                }
            }

            var cancel = function() {
                ($scope.callback) && $scope.callback(false);
                closeModal();
            }

            // ===============================
            //  開啟 modal
            // ===============================
            var openModal = function() {
            	$ngModal.openModal('confirm-modal');
            }

            // ===============================
            //  關閉 modal
            // ===============================
            var closeModal = function() {
                $scope.isLoading = false;
            	$ngModal.closeModal('confirm-modal');
            }

            /*==========================
                Events
            ==========================*/            
            $scope.$on('OPEN_CONFIRM_MODAL', function(event, data) {
                if(data) {
                    $scope.title = data.title;
                    $scope.description = data.description;
                    $scope.callback = data.callback;
                    $scope.waitLoading = data.waitLoading || false;
                }
            	openModal();
            });

            /*==========================
                Members
            ==========================*/
            $scope.title = undefined;
            $scope.description = undefined;
            $scope.isLoading = false;
            $scope.waitLoading = false;

            /*==========================
                Methods
            ==========================*/
            $scope.openModal = openModal;
            $scope.closeModal = closeModal;
            $scope.submit = submit;
            $scope.cancel = cancel;
            $scope.callback;

            
            /*==========================
                init
            ==========================*/

		}]

		_dir.restrict = "E";
		_dir.scope = true;
		_dir.templateUrl = "partials/modal/confirm.html";
		_dir.controller = controller;

		return _dir;
	}]
);